import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/common";

export default {
    /** 查询工地列表 */
    querySiteNoPage: (data = {}) => axios.get({url: `${PREFIX_URI}/querySiteNoPage`, data}),

    /** 查询项目列表 */
    queryProjectNoPage: () => axios.get({url: `${PREFIX_URI}/queryProjectNoPage`}),

    /** 查询所有施工班组 */
    queryClassmateNoPage: () => axios.get({url: `${PREFIX_URI}/queryClassmateNoPage`}),

    /** 查询所有施工人员 */
    queryWorkersNoPage: () => axios.get({ url: `${PREFIX_URI}/queryWorkersNoPage` }),

    /** 查询所有职员 */
    queryUserNoPage: (data = {}) => axios.get({ url: `/basedata/common/queryEmployeeList`, data }),

    /** 查询所有班组长 */
    queryClassLeaderNoPage: () => axios.get({ url: `${PREFIX_URI}/queryClassLeaderNoPage` }),

    /** 查询所有物资 */
    queryMaterialNoPage: (data = {}) => axios.get({ url: `/basedata/common/querySkuListNoPage`, data }),
}